/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';
import sanitizeHtml from 'sanitize-html';

const SanitizedHtml = ({ html }) => {
  const sanitizedHtml = html
    ? sanitizeHtml(html, {
        allowedTags: false,
        allowedAttributes: false,
      })
    : '';

  return <span dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

SanitizedHtml.propTypes = {
  html: PropTypes.string,
};

SanitizedHtml.defaultProps = {
  html: undefined,
};

export default SanitizedHtml;



// WEBPACK FOOTER //
// ./src/components/SanitizedHtml.js